import { __, T } from '../i18n'
import { ApiError } from './ApiError'

class ConnectionError extends ApiError {
  statusCode = 0
  message = __(T.errors.connection)
}

export default ConnectionError
